export var FIGURE_FORMATTING = 'FIGURE_FORMATTING';
export var FORMATTING = 'FORMATTING';
export var ILLUSTRATION = 'ILLUSTRATION';
export var JOURNAL_REC = 'JOURNAL_REC';
export var TABLE_FORMATTING = 'TABLE_FORMATTING';
export var AUTOMATED_RE_EDITING = 'AUTOMATED_RE_EDITING';
export var TOUCH_UP_EDITING = 'TOUCH_UP_EDITING';
export var TOUCH_UP_EDITING_FOR_TRANSLATION = 'TOUCH_UP_EDITING_FOR_TRANSLATION';
export var TOUCH_UP_FORMATTING = 'TOUCH_UP_FORMATTING';
export var SCIENTIFIC_EDITING = 'SCIENTIFIC_EDITING';
export var TYPE_EDITING = 'editing';
export var TYPE_TRANSLATION = 'translation';
export var TYPE_FORMATTING = 'formatting';
export var TYPE_FIGURES = 'figures';
export var TYPE_JOURNALREC = 'journalrec';
export var TYPE_PROMOTION = 'promotion';
export var AJE = {
  STANDARD_EDITING: 'e892c979-de5e-11ea-bf14-0242ac110004',
  ADVANCED_EDITING: '2d1d9a29-de5f-11ea-bf14-0242ac110004',
  PREMIUM_ADVANCED_EDITING: '236daa23-0d3b-4772-3cb0-cff5eb36d723',
  PREMIUM_EDITING: '2a94a10a-16e6-11e6-8c5d-0ac3cd229553',
  STANDARD_PORTUGUESE_TRANSLATION: '1474279e-f25d-432f-bdee-f4a6eb3c1c23',
  PREMIUM_CHINESE_TRANSLATION: '62d577ff-a71b-11e4-a43b-22000b3613bb',
  PREMIUM_SPANISH_TRANSLATION: '62d578b9-a71b-11e4-a43b-22000b3613bb',
  STANDARD_SPANISH_TRANSLATION: '238f4535-cd72-49c8-bc91-a490c59cd45c',
  PREMIUM_JAPANESE_TRANSLATION: 'c6583f4a-e6ce-11e5-862f-0ac3cd229553',
  REVERSE_TRANSLATION_ENGLISH_TO_PORTUGUESE: '62d715b9-a71b-11e4-a43b-22000b3613bb',
  REVERSE_TRANSLATION_ENGLISH_TO_SPANISH: '62d71819-a71b-11e4-a43b-22000b3613bb',
  REVERSE_TRANSLATION_ENGLISH_TO_CHINESE: '62d73158-a71b-11e4-a43b-22000b3613bb',
  FIGURE_FORMATTING: '399d9532-2b03-11e9-9e20-12b504df345a',
  TABLE_FORMATTING: '39a2111d-2b03-11e9-9e20-12b504df345a',
  FORMATTING: 'b8b2b6ac-4bfc-11e9-9e20-12b504df345a',
  ILLUSTRATION: '9ef3a37f-517c-11e9-9e20-12b504df345a',
  JOURNAL_REC: '9ef86690-517c-11e9-9e20-12b504df345a',
  AUTOMATED_RE_EDITING: '23ce40f0-43c8-41ac-8f37-a0d7054f4c0c',
  TOUCH_UP_EDITING: '491db2d8-5c7d-11e9-9e20-12b504df345a',
  TOUCH_UP_EDITING_FOR_TRANSLATION: '491ff663-5c7d-11e9-9e20-12b504df345a',
  TOUCH_UP_FORMATTING: '4920f096-5c7d-11e9-9e20-12b504df345a',
  SCIENTIFIC_EDITING: '3029cf2b-93c4-11ea-a626-0242ac110005'
};
export var STANDARD_TRANSLATION_SERVICES = [AJE.STANDARD_PORTUGUESE_TRANSLATION, AJE.STANDARD_SPANISH_TRANSLATION];
export var NPGLE = {
  SILVER_EDITING: '62d56c48-a71b-11e4-a43b-22000b3613bb',
  GOLD_EDITING: '62d56d88-a71b-11e4-a43b-22000b3613bb',
  PORTUGUESE_TRANSLATION: '3cfe86ac-29d3-11e7-bb48-0aa917e63cb8',
  CHINESE_TRANSLATION: '3d000ff5-29d3-11e7-bb48-0aa917e63cb8',
  SPANISH_TRANSLATION: '3d008944-29d3-11e7-bb48-0aa917e63cb8',
  JAPANESE_TRANSLATION: '3d010245-29d3-11e7-bb48-0aa917e63cb8',
  FIGURE_FORMATTING: '39a1bb52-2b03-11e9-9e20-12b504df345a',
  FORMATTING: 'b8b52f32-4bfc-11e9-9e20-12b504df345a',
  ILLUSTRATION: '9ef80ac7-517c-11e9-9e20-12b504df345a',
  TOUCH_UP_EDITING: '492146dc-5c7d-11e9-9e20-12b504df345a',
  TOUCH_UP_EDITING_FOR_TRANSLATION: '4921a04d-5c7d-11e9-9e20-12b504df345a',
  TOUCH_UP_FORMATTING: '4921f9a3-5c7d-11e9-9e20-12b504df345a',
  SCIENTIFIC_EDITING: '6e89f27e-bd52-11e9-9cb5-2a2ae2dbcce4'
};
export var availableServiceOptionsForLength = function availableServiceOptionsForLength(options, wordCount) {
  if (!wordCount) {
    return [];
  }
  return options.filter(function (option) {
    return option.lengthLow <= wordCount && wordCount <= option.lengthHigh;
  }).sort(function (a, b) {
    return parseFloat(a.price) > parseFloat(b.price) ? 1 : -1;
  });
};